// extracted by mini-css-extract-plugin
module.exports = {"quote-row":"quote-row__quote-row___1HBTj","quote-row-content":"quote-row__quote-row-content___33xmQ","dog-ear":"quote-row__dog-ear___gwa3j"};